import { IconSearch, IconCross } from '../ui'
import uniqid from 'uniqid'
import { Form } from 'react-bootstrap'
import { IFilterInput } from '../../types'

export const FilterInput = (props: IFilterInput) => {
	const {
		attr,
		value,
		setValue,
		label,
		placeholder,
		styles = {},
		isClearable = false,
		isDisabled = false,
		isIconRightVisible = false,
		iconRight = <IconSearch size={20}/>
	} = props
	const key = uniqid()

	return (
		<div className="filter-input-cont" style={styles}>
			{label ? <Form.Label className="text-dark" htmlFor={`input-${key}`}>{label}</Form.Label> : null}

			<div className={'src-form position-relative'}>
				<input
					type="text"
					id={`input-${key}`}
					className="form-control"
					autoComplete={'off'}
					{...attr}
					placeholder={placeholder ?? ''}
					disabled={isDisabled}
					value={value ?? ''}
					onChange={(event) => setValue(event.target.value)}
				/>

				<div className={'input-buttons bg-transparent position-absolute top-50 translate-middle-y'}>
					{!isDisabled && isClearable && value?.length > 0 ? (
						<i className="icon-cross"
						   onClick={(event) => setValue('')}
						>
							<IconCross/>
						</i>
					) : null}

					{isIconRightVisible ? (
						<>
							<span className="indicator-separator"></span>

							<i className="icon-right">
								{iconRight}
							</i>
						</>
					) : null}
				</div>
			</div>
		</div>
	)
}